import { create } from 'zustand';

interface FeedbackModalState {
  visible: boolean;
  context: Record<string, unknown> | null;
}

export const useFeedbackModalStore = create<FeedbackModalState>(() => ({
  visible: false,
  context: null,
}));
